module.exports = __webpack_public_path__ + "img/pentest-white.00daad48.png";